import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import ConnectDomruPopupGroup from '@r1-frontend/entities/ConnectDomruPopup';
import { setView } from '@r1-frontend/entities/ConnectDomruPopup/context/actions';
import { useContextDispatch } from '@r1-frontend/entities/ConnectDomruPopup/context/hooks';
import { TPopupGroupState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';
import UnauthDesktopHeader from '@r1-frontend/entities/Layout/Header/desktop/components/UnauthDesktopHeader';
import UnauthMobileHeader from '@r1-frontend/entities/Layout/Header/mobile/UnauthMobileHeader';
import { IUnauthHeaderProps } from '@r1-frontend/entities/Layout/Header/types';
import { selectUnauthMenu } from '@r1-frontend/entities/stores/city/selectors/selectMenu';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

export const UnauthHeader = () => {
    const newMenuItems = useSelector(selectUnauthMenu);
    const { asPath } = useRouter();
    const dispatch = useContextDispatch();

    const togglePopupState = useCallback((state: TPopupGroupState) => {
        if (state === 'connect') {
            dataLayerPush({
                event: EVENTS.UAevent,
                category: CATEGORIES.mainMenuClick,
                action: 'Подключить Дом.ру',
                label: 'menu_new',
            });
        }

        dispatch(setView(state));
    }, []);

    const props: IUnauthHeaderProps = {
        items: newMenuItems,
        onBecomeClientHandler: togglePopupState,
        referrerPath: `?referrer=${decodeURIComponent(asPath)}`,
    };

    return (
        <>
            <UnauthDesktopHeader {...props}/>
            <UnauthMobileHeader {...props}/>
            <ConnectDomruPopupGroup/>
        </>
    );
};
